import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import privateLibraryActions from 'redux/actions/privateLibraryActions'
import generalActions from 'redux/actions/generalActions'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT

const LessonAddedredirectConfirm = props => {
	let alertTitle = ''
	if (props.entityType === 'bundle') {
		alertTitle = props.libraryType === 'school' ? localize('privateLibrary_admin_bundleAddedToSchool') : localize('privateLibrary_admin_bundleAddedToDistrict')
	} else {
		alertTitle = props.libraryType === 'school' ? localize('privateLibrary_admin_lessonAddedToSchool') : localize('privateLibrary_admin_lessonAddedToDistrict')
	}
	return (<Confirm
		btOne={localize('privateLibrary_admin_lessonAddedGoToLibrary')}
		btTwo={localize('privateLibrary_admin_lessonAddedStayExplore')}
		alertTitle={alertTitle}
		centeredTitle={true}
		alertMessage=''
		actionOne={props.actions.manageLibrary.bind(this, props.libraryId)}
		actionTwo={props.actions.viewLibrary.bind(this, props.libraryId)}
		closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)} />)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		manageLibrary: privateLibraryActions.manageLibrary_confirm,
		viewLibrary: privateLibraryActions.viewLibrary_confirm,
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(LessonAddedredirectConfirm)
